import { CustomTestCreateWizardContext } from 'pages/custom_tests_v1/components/custom_test_create_wizard/context';
import { CustomTestSettings } from 'pages/custom_tests_v1/components/CustomTestSettings';
import { FormattedMessage } from 'react-intl';

export const DetailsStep = props => (
    <div className="py-3">
        <h5 className="mb-2">
            {<FormattedMessage defaultMessage="Test Details" id="test_details.88f73a4e" />}
        </h5>
        <p className="text-muted mb-4">
            {<FormattedMessage defaultMessage="Configure the basic settings for your custom test." id="configure_the_basic_settings_for_your_cu.57c7e331" />}
        </p>
        <CustomTestSettings context={CustomTestCreateWizardContext} showRandomize={false}/>
    </div>
);
